import React from "react";
import "../components/css/style.css";

import BreadcrumbIllustration from "../assets/imgs/img_banner.png";

export default function ServicesSection() {
    const handleHomeClick = (e) => {
        e.preventDefault();
        window.location.href = "/";
    };

    return (
        <section className="abt-section">
        <div className="abt-container">
            <div className="abt-left">
            <h1 className="abt-title">
                <span className="abt-highlight">Our Services & Pricings</span>
            </h1>

            <div className="abt-breadcrumb">
                <span className="abt-crumb abt-home" onClick={handleHomeClick}>Home</span>
                <span className="abt-crumb abt-active">About Us</span>
            </div>
            </div>

            <div className="abt-right">
            <div className="abt-image-wrapper">
                <img
                src={BreadcrumbIllustration}
                alt="Illustration"
                className="abt-image"
                />
            </div>
            <div className="abt-glow"></div>
            <div className="abt-glow abt-glow-second"></div>
            </div>
        </div>
        </section>
    );
}